export default __webpack_public_path__ + "static/media/leftBG.2854661c.svg";